import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { DynamicFieldModel } from '@share';
import { LoadingService } from 'src/app/share/services/loading.service';
import { BizPostService } from './biz-post.service';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { environment } from 'src/environments/environment';
import { SubcategoryService } from '../subcategory/subcategory.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CommonModule, DatePipe } from '@angular/common';
import { requireIfValueIs } from 'src/app/share/validators/dynamic-requiredIf-validator';
import { filter, forkJoin } from 'rxjs';
import { ExcelService } from 'src/app/share/services/excel.service';

const apiurl = environment.apiUrl;

@Component({
  selector: 'app-biz-post',
  imports: [DynamicTableComponent, CommonModule],
  providers: [NzModalService, DatePipe],
  templateUrl: './biz-post.component.html',
  styleUrl: './biz-post.component.scss'
})
export class BizPostComponent implements OnInit {
  constructor(private datePipe: DatePipe, private readonly service: BizPostService, private readonly subcategoryService: SubcategoryService, private readonly loadingService: LoadingService, private readonly cdr: ChangeDetectorRef, private readonly modalService: NzModalService, private readonly excelService: ExcelService) {

  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();

  }
  @HostListener('window:resize')
  calculateWidth() {
    const offsetWidth = 300;
    this.width = `${window.innerWidth - offsetWidth}px`;
  }
  ngOnInit(): void {
    this.calculateWidth();

    forkJoin({
      groups: this.service.getGroupItems(),
      mainCategories: this.service.getMainCategoryItems(),
      categories: this.service.getCategoryItems(),
      subCategories: this.service.getSubCategoryItems(),
      bizPosts: this.service.getItems()
    })
      .subscribe({
        next: ({ groups, mainCategories, categories, bizPosts }) => {
          // Populate search dropdowns
          this.schema.columns[2].option = bizPosts?.data
            .map((y: any) => ({
              text: y.product_name,
              value: y.product_name
            }))
            .filter((item: any, index: number, self: any[]) =>
              index === self.findIndex((t: any) => t.text === item.text && t.text)
            );

          this.schema.columns[3].option = bizPosts?.data
            .filter((post: any) => post.type === 'Biz Post')
            .map((y: any) => ({
              text: y.content,
              value: y.content
            }))
            .filter((item: any, index: number, self: any[]) =>
              index === self.findIndex((t: any) => t.text === item.text && t.text)
            );

          this.schema.columns[4].option = groups?.data.map((y: any) => ({
            text: y.group_name,
            value: y.group_name
          }));

          this.schema.columns[5].option = mainCategories?.data
            ?.filter((y: any) => y.type === 'Biz Post')
            .map((y: any) => ({
              text: y.maincategory_name,
              value: y.maincategory_name
            }));

          this.schema.columns[6].option = categories?.data
            ?.filter((y: any) => y.type === 'Biz Post')
            .map((y: any) => ({
              text: y.category_name,
              value: y.category_name
            }));


          this.fieldConfig[1].options = groups?.data.map((y: any) => ({
            text: y.group_name,
            value: y.id
          }));
        },
        error: err => console.error('Error loading options:', err),
        complete: () => {
          // Set default status to 'published' for business posts
          const statusField = this.fieldConfig.find(field => field.name === 'status');
          if (statusField) {
            statusField.value = 'published';
          }

          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params);
        }
      });
  }
  width: string;
  total = 0;
  schema = {
    name: "Business Post List",
    permissionKey: "bizpost",
    enableDelete: true,
    enableEdit: true,
    enableAdd: false,
    enableDownload: false,
    size: "middle",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight: false,
        isStickyLeft: true,

      },
      {
        key: "imageUrl",
        title: "image",
        type: "image",
        width: "100px",
        isStickyRight: false,
        isStickyLeft: false,

      },
      {
        key: "product_name",
        title: "Product Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "content",
        title: "Content",
        type: "string",
        enableSearch: true,
        //enableSort: true,
        searchType: "input",
        // option: [] as any[],
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,

      },
      {
        key: "group_name",
        title: "Group Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "230px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "maincategory_name",
        title: "Main Category Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "category_name",
        title: "Category",
        type: "object",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "230px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      // {
      //   key: "subcategory_name",
      //   title: "Sub Category Name",
      //   type: "string",
      //   enableSearch: true,
      //   searchType: "select",
      //   option: [] as any[],
      //   width: "260px",
      //   isStickyRight: false,
      //   isStickyLeft: false,
      // },
      {
        key: "createdType",
        title: "Created By",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [{ value: "user", text: "User" }, { value: 'admin', text: "Admin" }],
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "status",
        title: "Status",
        type: "tag",
        enableSearch: true,
        searchType: "select",
        option: [
          { value: "draft", text: "Draft" },
          // { value: "scheduled", text: "Scheduled" },
          { value: "published", text: "Published" }
        ],
        width: "180px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        isStickyRight: true,
        isStickyLeft: false,
        label: [
          { name: "edit", type: "edit", isDanger: false, isEnable: true }, { name: "delete", type: "danger", isEnable: true }
        ]//,{name:"delete",type:"danger"}
      }
    ]
  };

  fieldConfig: Array<DynamicFieldModel> = [
    {
      name: 'image',
      type: 'multi-image-file',
      label: 'Upload Image',
      readonly: false,
      required: false
    },
    {
      label: 'Group Name',
      name: 'group_id',
      type: 'select',
      required: true,
      placeholder: 'Group Name',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Group Name required',
        },
      ],
    },
    {
      label: 'Main Category Name',
      name: 'maincategory_id',
      type: 'select',
      required: true,
      placeholder: 'Main Category Name',
      dependOn: 'group_id',
      matchType: 'Biz Post',
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Main Category Name required',
        },
      ],
    },
    {
      label: 'Category Name',
      name: 'category_id',
      type: 'select',
      required: true,
      placeholder: 'Category Name',
      dependOn: 'maincategory_id',
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Category Name required',
        },
      ],
    },
    // {
    //   label: 'Sub Category Name',
    //   name: 'subcategory_id',
    //   type: 'select',
    //   required: true,
    //   placeholder: 'Sub Category Name',
    //   dependOn: 'category_id',
    //   optionUrl: 'categoryhierarchy/option',
    //   options: [
    //   ],
    //   validations: [
    //     {
    //       name: 'required',
    //       validator: Validators.required,
    //       message: 'Sub Category Name required',
    //     },
    //   ],
    // },
    {
      label: 'Product Name',
      name: 'product_name',
      type: 'input',
      placeholder: 'Enter Product Name',
      required: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Product Name required',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    },
    {
      label: 'Content',
      name: 'content',
      type: 'quill-text',
      class: 'col-md-6',
      placeholder: 'Content',
      required: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Content required',
        },
      ],
    },
    {
      label: 'Post Type',
      name: 'type',
      type: 'hidden',
      value: 'Biz Post'
    },
    {
      label: 'Status',
      name: 'status',
      type: 'select',
      class: 'col-md-6',
      placeholder: 'Select Status',
      required: true,
      options: [
        { value: 'draft', text: 'Draft' },
        // { value: 'scheduled', text: 'Scheduled' },
        { value: 'published', text: 'Published' },
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Status required',
        },
      ],
    },
    // {
    //   label: 'Schedule Date',
    //   name: 'scheduled_date',
    //   type: 'dateTime',
    //   class: 'col-md-6',
    //   placeholder: 'Select scheduled date',
    //   hideByField: 'status',
    //   hideByFieldValue: 'draft,published',
    //   showPicker: true,
    //   minDate: new Date(),
    //   dependOn: 'status',
    //   validations: [
    //     {
    //       name: 'requiredIf',
    //       validator: requireIfValueIs('status', 'scheduled'),
    //       message: 'Scheduled Date is required when status is Scheduled',
    //     }
    //   ]
    // }
  ];

  report = {
    name: "Business Post Report",
    file_name: "Business_Post_Report",
    header: [
      {
        label: "No",
        fieldName: "no",
        tag: "no",
        width: 5
      },
      {
        label: "Business Post Id",
        fieldName: "id",
        class: "align-left",
        width: 30
      },
      {
        label: "Product Name",
        fieldName: "product_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Content",
        fieldName: "content",
        objFieldName: "content",
        class: "align-left",
        width: 30
      },
      {
        label: "Group Name",
        fieldName: "group_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Main Category Name",
        fieldName: "maincategory_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Category Name",
        fieldName: "category_name",
        class: "align-left",
        width: 30
      },
      // {
      //   label: "Sub Category Name",
      //   fieldName: "subcategory_name",
      //   class: "align-left",
      //   width: 30
      // },
      {
        label: "Created By",
        fieldName: "createdType",
        class: "align-left",
        width: 20
      },
      {
        label: "Status",
        fieldName: "status",
        class: "align-left",
        width: 20
      },
    ]
  };

  list: any[] = [];
  currentTime: Date = new Date();

  getCellValue(row: any, column: any): string {
    // Handle image column to show first image
    if (column.fieldName === 'image') {
      if (row.image && Array.isArray(row.image) && row.image.length > 0) {
        return row.image[0].url || row.image[0];
      }
      return '';
    }

    if (column.fieldName === "eng_version") {
      if (row[column.fieldName]) {
        return 'mm , en';
      }
      else {
        return 'mm'
      }
    }
    if (!row[column.fieldName.split('.')[0]]) return ''
    const result: string = column.fieldName
      .split('.')
      .reduce((prev: any, curr: string) => prev[curr], row)
    if (column.pipe) {
      switch (column.pipe) {
        case 'shortDateTime': {
          return this.datePipe.transform(result)
        }
      }
    }

    return result
  }

  change(data: { [key: string]: any }) {
    if (data['type'] == 'download') {
      // Add type to filters for download
      let filters = data['filters'] || {};
      filters.type = 'Biz Post';

      let params = new HttpParams()
        .set('filterValue', JSON.stringify(filters));
      this.loadingService.toggleTableLoading()
      this.service.getItems(params).subscribe({
        next: x => {
          let data = x.data;
          if (data !== undefined && data.length !== 0) {
            const value = []
            for (let i = 0; i < data?.length; i++) {
              const item: any = {}
              for (const row of this.report.header) {
                const head = row
                if (!head.hasOwnProperty('objFieldName')) {
                  if (head.tag === 'no') item[head.label] = i + 1
                  else if (head.tag === 'number')
                    item[head.label] = data[i][head.fieldName]
                      ? data[i][head.fieldName]
                      : 0
                  else if (head.tag === 'pipe') {
                    const [field1, field2] = head.fieldName.split('|');
                    const value = data[i][field1];
                    item[head.label] = value !== '' && value != null
                      ? value
                      : data[i][field2] ?? '';
                  }
                  else if (head.tag === 'datetime') {
                    item[head.label] = data[i][head.fieldName]
                      ? this.datePipe.transform(new Date(data[i][head.fieldName]), 'dd-MM-yyyy HH:mm')
                      : ''
                  }
                  else
                    item[head.label] = data[i][head.fieldName]
                      ? data[i][head.fieldName]
                      : ''
                } else {
                  item[head.label] =
                    data[i][head.objFieldName] !== null
                      ? this.getCellValue(data[i], head)
                      : ''
                }
              }
              value.push(item)
            }
            const dynamicName = `${this.report.file_name
              }_${this.currentTime.getDate()}_${this.currentTime.getMonth() + 1
              }_${this.currentTime.getFullYear()}`;
            this.excelService.exportAsExcelFile(
              value,
              dynamicName,
              this.report.header
            )
          }
        },
        error: err => this.loadingService.toggleTableLoading(),
        complete: () => this.loadingService.toggleTableLoading()
      });
    }
    else {
      let params = new HttpParams()
        //.set('searchValue',this.searchValue)
        .set('page', data['pageIndex'].toString())
        .set('pageSize', data['pageSize'].toString())
        .set('filterValue', JSON.stringify(data['filters']))
        .set('sort', JSON.stringify(data['sorts']));
      this.loadData(params);
    }
  }

  loadData(param: HttpParams = null, needLoading: boolean = true) {
    if (needLoading) {
      this.loadingService.toggleTableLoading();
    }

    // Add type filter to ensure we only get Biz Posts from the backend
    let params = param || new HttpParams();

    // Check if filterValue exists and add type to it
    if (params.has('filterValue')) {
      try {
        let filterValue = JSON.parse(params.get('filterValue'));
        filterValue.type = 'Biz Post';
        params = params.set('filterValue', JSON.stringify(filterValue));
      } catch (e) {
        // If parsing fails, create new filterValue with type
        params = params.set('filterValue', JSON.stringify({ type: 'Biz Post' }));
      }
    } else {
      // If no filterValue exists, create one with type
      params = params.set('filterValue', JSON.stringify({ type: 'Biz Post' }));
    }

    this.service.getItems(params).subscribe({
      next: x => {
        this.list = x.data || [];
        this.list.forEach(item => {
          item.imageUrl = Array.isArray(item.image) && item.image.length > 0
            ? item.image[0].url || item.image[0]
            : '';
        });
        this.total = x.totalCount || 0;
      },
      error: err => this.loadingService.toggleTableLoading(),
      complete: () => {
        this.loadingService.toggleTableLoading();
        this.cdr.detectChanges();
      }
    });
  }

  formEvent(data: any) {
    if (data.id) {
      if (data.title === '') {
        delete data.title; // convert empty string to null
      }
      this.loadingService.toggleTableLoading();
      this.service.updateItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params, false);
      });
    }
    else if (data.deleted_id) {
      this.loadingService.toggleTableLoading();
      this.modalService.confirm({
        nzTitle: 'Are you sure want to delete?',
        nzContent: 'This action cannot be undone.',
        nzOkText: 'Yes',
        nzCancelText: 'No',
        nzOnOk: () => {
          this.service.deleteItem(data).subscribe({
            next: x => {
              let params = new HttpParams()
                .set('page', this.schema.pageIndex.toString())
                .set('pageSize', this.schema.pageSize.toString());
              this.loadData(params, false);
            },
            error: err => console.log(err)
          });
        },
        nzOnCancel: () => {
          this.loadingService.toggleTableLoading();
        }
      });
    }
  }
}
